import { provide } from 'vue';

export default function useCreditCardFieldsContext() {
    provide('creditCardFieldsContext', {
        legacyStripeElementsEnabled: false,
        legacyStripeElementsUrl: window.__KEAP__.VUE_APP_STRIPE_ELEMENTS_URL,
        onStripeProcessedAnalytics: () => {},
    });
}
